if (!customElements.get('tab-component')) {
  customElements.define(
    'tab-component',
    class TabComponent extends HTMLElement {
      constructor() {
        super();

        this.tabs = this.querySelectorAll('.tab__button');
        this.panels = this.querySelectorAll('.tab__panel');

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            const controls = tab.getAttribute('aria-controls');

            this.tabs.forEach((tab) => {
              tab.setAttribute('aria-selected', 'false');
            });

            this.panels.forEach((panel, index) => {
              if (controls.indexOf(panel.id) > -1) {
                panel.setAttribute('aria-expanded', 'true');
              } else {
                panel.setAttribute('aria-expanded', 'false');
              }
            });

            tab.setAttribute('aria-selected', 'true');
          });
        });
      }
    }
  );
}
